export {};

export function validateIfCheckinAndCheckoutDateAreEntered(hotels: any) {
  if (hotels?.length === 0) return false;
  let isValid = true;
  hotels?.forEach((ele: any) => {
    if (ele?.checkIn === "" || ele?.checkOut === "") isValid = false;
  });
  return isValid;
}

export function getNextDateYYYYMMDD(checkIn: string, days: number): string {
  // const date = new Date(checkIn);
  // date.setDate(date.getDate() + days);

  // // Format as YYYY-MM-DD
  // return date.toISOString().split("T")[0];
  const [y, m, d] = checkIn.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  date.setDate(date.getDate() + days);

  // Format as YYYY-MM-DD using local time getters
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Flight+Stays prefill: checkout comes from the return flight's date. A same-day (or earlier)
// return would give a zero-night stay, so use check-in + 1 night instead (SMB-4415).
export function resolveStayCheckOutFromFlight(checkIn?: string, returnDate?: string): string {
  if (checkIn && returnDate && returnDate <= checkIn) return getNextDateYYYYMMDD(checkIn, 1);
  return returnDate || "";
}
